import { homeSecurityPortalApi } from 'data/axios';
import { TPlanList, TSkipList, TSkipReason } from 'typings';
import { ApiResponse } from './HttpRequest';
import { PIGGYBANK_ENDPOINTS } from './endpoints';

export async function birdSkipFreeTrialReason(payload: TSkipReason) {
  const response = await homeSecurityPortalApi.post(
    PIGGYBANK_ENDPOINTS.BIRD_USER_SKIP_REASON,
    payload
  );
  return response;
}

export async function birdSkipFreeTrialList(): Promise<
  ApiResponse<TSkipList[]>
> {
  const response = await homeSecurityPortalApi.get(
    PIGGYBANK_ENDPOINTS.BIRD_TRIAL_SKIP_REASON
  );
  return response;
}

export async function getBirdPlans(
  country: string
): Promise<ApiResponse<TPlanList[]>> {
  const response = await homeSecurityPortalApi.get(
    PIGGYBANK_ENDPOINTS.BIRD_PLAN_LIST(country)
  );
  return response;
}
